// @flow

import * as React from 'react';

import { Button, Footer } from '@sonyged/ext-proc';

import type { FinishedRound } from './domain/Round';
import AppContext from '../../../AppContext';
import AutoScaleContainer from './AutoScaleContainer';
import PizzaContainer from './PizzaContainer';
import PizzaHera from './PizzaHera';
import PizzaOven from './PizzaOven';

type Props = {
  round: FinishedRound,
  onNext: FinishedRound => void,
};

class PizzaBakingView extends React.Component<Props> {
  static contextType = AppContext;

  constructor(props: Props) {
    super(props);

    (this: any).handleAnimationEnd = this.handleAnimationEnd.bind(this);
  }

  handleAnimationEnd() {
    setTimeout(() => {
      this.props.onNext(this.props.round);
    }, 1000);
  }

  componentDidMount() {
    this.context.soundController.sePlay('juuuu');
  }

  render() {
    return (
      <div className="pizza-inner-view pizza-cooking-view">
        <div className={'proc-contents padding'}>
          <AutoScaleContainer preferedWidth={864} preferedHeight={474} preferedMinHeight={474} preferedMinWidth={360}>
            <PizzaOven>
              <PizzaHera />
              <PizzaContainer pizza={this.props.round.pizza} onAnimationEnd={this.handleAnimationEnd} />
            </PizzaOven>
          </AutoScaleContainer>
        </div>
        <Footer.normal>
          <Button.attention disabled>つぎへ</Button.attention>
        </Footer.normal>
      </div>
    );
  }
}

export default PizzaBakingView;
